import React from 'react'
import styles from '../../../css/services/conServices.module.css';
function SaberServices() {
  return (
      <div className={styles.container}>
          <div className={styles.services}>
              <div>
                  <h1>1. تسجيل حساب منشئة Establishing an entity account</h1>
                  <p>
                      خدمة تمكين المنشأة من تسجيل حساب رسمي لتحديد هويتها
                      <br/>
                      وتيسير العمليات الرسمية.

                  </p>
              </div>
              <div>
                  <h1>2. تفاويض (Delegating)</h1>
                  <p>
                      خدمة تمكين الأفراد أو الكيانات من منح صلاحيات لشخص آخر
                      لتنفيذ مهمة محددة بالنيابة عنهم، مع توثيق رسمي
                  </p>
              </div>
          </div>
      </div>
  )
}

export default SaberServices